import { snackbarError, logApplicationInsightsError } from '../SharedFunctions';

export const handleAdminError = (error: Error, snackbarMessage = 'An error has occurred. Please contact your administrator.') => {
    if (process.env.NODE_ENV === 'development') {
        console.log('handleAdminError', error);
    }

    snackbarError(snackbarMessage);

    logApplicationInsightsError(error);
};
